import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';

const GRAPHQL_DOCUMENT = gql`
  mutation cleoPatientFormMetadataEntryUpdate(
    $input: UpdateCleoPatientFormMetadataEntryInput!
  ) {
    cleoPatientFormMetadataEntryUpdate(input: $input) {
      cleoPatientFormMetadataEntry {
        uid
        parameter {
          name
        }
        extractedForDisplay
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'patientFormMetadataEntry',
  keepPreviousData: false,
});
